import { FC, useEffect } from 'react';

import styles from './NrRedirect.module.scss';

const TARGET_URL = 'https://nr-target.ru/?utm_source=scan';
const REDIRECT_DELAY_MS = 1500;

const NrRedirect: FC = () => {
  useEffect(() => {
    document.title = 'Переадресация на сайт';
    const timer = window.setTimeout(() => {
      window.location.href = TARGET_URL;
    }, REDIRECT_DELAY_MS);
    return () => window.clearTimeout(timer);
  }, []);

  const handleManualRedirect = () => {
    window.location.href = TARGET_URL;
  };

  return (
    <div className={styles.container}>
      <div className={styles.loader} />
      <h1 className={styles.title}>Переадресация на сайт</h1>
      <p className={styles.subtitle}>
        Вы будете перенаправлены через 1,5 секунды…
      </p>
      <button type="button" className={styles.link} onClick={handleManualRedirect}>
        Перейти сейчас
      </button>
    </div>
  );
};

export default NrRedirect;
